import { inheritSerialization, autoserializeAs } from 'cerialize'

import { ExpenseStatus, IExpense } from './interfaces'
import { Ledger } from '.'

@inheritSerialization(Ledger)
export default class Expense extends Ledger implements IExpense {

  @autoserializeAs('receipt_ref_code')
  public receiptRefCode: string = ''

  @autoserializeAs('paid_date')
  public paidDate: Date|undefined = undefined

  @autoserializeAs('status')
  public status: ExpenseStatus = 'created'

  @autoserializeAs('payee_id')
  public payeeId: string = ''

  @autoserializeAs('deduct_percent')
  public deductPercent: number = 0

  public get deductAmount(): number {
    return +((this.total - this.totalVat) * (this.deductPercent / 100)).toFixed(2)
  }

  public constructor() {
    super('exp')
  }
}
